<template>
  <v-layout row justify-center>
    <v-layout row justify-center>
      <v-dialog v-model="dialog" persistent width="50%">
        <v-card v-if="plan">
          <v-toolbar flat>
            <v-toolbar-title>{{
              $t("company.pricing.plan.checkout.dialog.title")
            }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon color="error" @click.native="$emit('reset')"
              >$vuetify.icons.rms_close</v-icon
            >
          </v-toolbar>
          <v-card-text>
            <v-card-actions>
                <h1>{{plan.metadata.plan_name}}</h1>
                <v-spacer></v-spacer>
                <a flat target="_blank" :href="'/vod/geo-graphical-catalogue'" class="success--text" outline>{{$t('company.pricing.plan.checkout.catalogue.btn')}}</a>
            </v-card-actions>
            <v-list class="px-3 mb-4">
                <v-list-tile
                v-for="(feature, i) in DEFINES.PRICING_PLANS[plan.interval].features"
                :key="i"
                avatar
                >
                <v-list-tile-action>
                    <v-icon color="success">check</v-icon>
                </v-list-tile-action>

                <v-list-tile-content>
                    <v-list-tile-title v-text="feature"></v-list-tile-title>
                </v-list-tile-content>
                </v-list-tile>
            </v-list>
            <div class="pa-2">{{DEFINES.PRICING_PLANS[plan.interval].checkoutNote}}</div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" flat @click.native="$emit('reset')"
              >Disagree</v-btn
            >
            <v-btn color="primary" flat @click.native="initiateEnrollment"
              >Agree</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
    <Enrollment
      :dialog.sync="enrollmentDialog"
      :plan.sync="plan"
      :modeOfUse="DEFINES.ENROLLMENT_COMP.MODE_OF_USE.SUBSCRIPTION"
    ></Enrollment>
  </v-layout>
</template>
<script>
import Enrollment from "@/components/company/Enrollment";

export default {
  name: "SubscriptionCheckoutDialog",
  props: {
    btnText: {
      type: String,
      default: "Dialog",
    },
    plan: {
        type: Object,
        default: null
    },
    dialog:{
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      enrollmentDialog: false
    };
  },
  components:{
    Enrollment
  },
  methods:{
    initiateEnrollment() {
      this.$emit('close');
      this.enrollmentDialog = true;
    }
  }
};
</script>
